import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { get } from 'lodash'
import I18n from 'I18n'

ButtonSign.propTypes = {
  type: PropTypes.string.isRequired,
  constructorFunctions: PropTypes.object.isRequired,
  withinDropdown: PropTypes.bool
}

export default function ButtonSign({
  type,
  constructorFunctions,
  withinDropdown = false
}) {
  return (
    <Button
      className={withinDropdown ? 'btn-within-dropdown' : ''}
      icon='form'
      type={withinDropdown ? 'ghost' : 'primary'}
      onClick={e => {
        e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown

        switch (type) {
          case 'firePermit':
            get(constructorFunctions, 'askSignPermit')('firePermit')
            break
          case 'searchPermit':
            get(constructorFunctions, 'askSignPermit')('searchPermit')
            break
          case 'capacityPermit':
            get(constructorFunctions, 'askSignPermit')('capacityPermit')
            break
          case 'cleaningPermit':
            get(constructorFunctions, 'askSignPermit')('cleaningPermit')
            break
          default:
            get(constructorFunctions, 'askSignPermit')('permit')
        }
      }}
    >
      {I18n.t('pages.permits.actions.sign')}
    </Button>
  )
}
